export default 'Please use a password of at least 6 characters that’s unique to InterNations'
